import React from 'react'
import { useRef } from 'react';
import { randomRange } from 'react-sdk/utils';
import SoundPlayer from '../../../js/SoundPlayer';

import './Button.css'


const Button = ({className, tabIndex=0, children, type="button", disabled, onClick, clickSound = "click"}) => {


  function handleMouseEnter() {
    SoundPlayer.playSound("rollOver")
  }
  function handleClick(e) {
    SoundPlayer.playSound(clickSound)
    onClick(e)
  }


  let classe = "Button"
  if(className) classe += " " + className



  return (
    <button tabIndex={tabIndex} className={classe} onClick={handleClick} type={type} disabled={disabled} onMouseEnter={handleMouseEnter}>
      {children}
    </button>
  );
}

export default Button;
